import structureFieldsQuery from "application/queries/form/structureFieldsQuery";
import translatable from "./translatable";

const searchForm = (id) =>
  `
  form(id: "${id}"){
    id
    name
    nameTranslatable {
      ${translatable}
    }
    description
    confirmation
    literalButton
    ${structureFieldsQuery}
  }
  `;

export default searchForm;
